import React, { useState, useEffect } from 'react'
import { CompareMobilePrefillDataAPi } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import NoData from '../../../../../images/nodata.png'
import Popup from '../../../../presentationals/Popup/Popup.component'

export default function FetchPrefillDataPopup({ userdata, admin, hnadlePrefetchPopupOpenPopup }) {
    const [loader, setLoader] = useState(false);
    const [popup, setpopup] = useState({ show: false, popupStatus: "" });
    const [prefillData, setPrefillData] = useState({});

    const closePopup = () => { setpopup({ show: false, popupStatus: "" }) }
    const removePopup = () => { setTimeout(() => { closePopup() }, 5000) }

    useEffect(() => {
        FetchData();
    }, []);

    const FetchData = () => {
        setLoader(true);
        CompareMobilePrefillDataAPi(userdata?.userId, (callback) => {
            setLoader(false);
            if (callback && callback.comparison) {
                setPrefillData(callback);
            } else {
                setpopup({ show: true, popupStatus: "No comparison record found." })
                removePopup()
                setPrefillData({});
            }
        });
    };

    const hasData = prefillData && prefillData.comparison && Object.keys(prefillData.comparison).length > 0;
    const comp = prefillData.comparison || {};

    const comparisonRows = [
        { label: 'Full Name', data: comp.name },
        { label: 'Mobile Number', data: comp.mobile },
        { label: 'Email Address', data: comp.email },
        { label: 'PAN Number', data: comp.pan },
        { label: 'Date of Birth', data: comp.dob },
        { label: 'Gender', data: comp.gender },
        { label: 'Current Address', data: comp.address?.currentAddress },
        { label: 'Permanent Address', data: comp.address?.permanentAddress },
    ].filter(row => row.data);

    return (
        <>
            {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""}
            
            <style>{`
                .prefill-popup-backdrop {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.4);
                    backdrop-filter: blur(8px);
                    z-index: 1040;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .prefill-popup-card {
                    background: #ffffff;
                    border-radius: 16px;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                    padding: 28px;
                    max-width: 900px;
                    width: 90%;
                    max-height: 85vh;
                    overflow-y: auto;
                    position: relative;
                    color: #1e293b;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }
                .prefill-close-btn {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    border: none;
                    background: #f1f5f9;
                    color: #64748b;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .prefill-close-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                    transform: rotate(90deg);
                }
                .prefill-title {
                    font-size: 20px;
                    font-weight: 750;
                    text-align: left;
                    margin-bottom: 20px;
                    padding-bottom: 12px;
                    border-bottom: 2px solid #f1f5f9;
                    background: linear-gradient(135deg, #1e293b, #475569);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .prefill-overall-card {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 14px 20px;
                    border-radius: 10px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    margin-bottom: 20px;
                }
                .prefill-overall-info {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .prefill-overall-title {
                    font-size: 14px;
                    font-weight: 600;
                    color: #475569;
                }
                .prefill-overall-status {
                    font-size: 13px;
                    font-weight: 700;
                    padding: 4px 12px;
                    border-radius: 20px;
                    text-transform: uppercase;
                }
                .prefill-overall-status.matched {
                    background-color: #dcfce7;
                    color: #15803d;
                }
                .prefill-overall-status.not_matched {
                    background-color: #fee2e2;
                    color: #b91c1c;
                }
                .prefill-table-wrapper {
                    width: 100%;
                    overflow-x: auto;
                    border-radius: 10px;
                    border: 1px solid #e2e8f0;
                }
                .prefill-table {
                    width: 100%;
                    border-collapse: collapse;
                    text-align: left;
                }
                .prefill-table th {
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 14px 16px;
                    border-bottom: 1.5px solid #e2e8f0;
                }
                .prefill-table td {
                    padding: 14px 16px;
                    font-size: 13px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                    vertical-align: top;
                }
                .prefill-table tr:last-child td {
                    border-bottom: none;
                }
                .prefill-field-label {
                    font-weight: 600;
                    color: #1e293b;
                }
                .prefill-badge {
                    display: inline-flex;
                    align-items: center;
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                }
                .prefill-badge.matched {
                    background-color: #dcfce7;
                    color: #15803d;
                }
                .prefill-badge.not_matched {
                    background-color: #fee2e2;
                    color: #b91c1c;
                    white-space:nowrap;
                }
                .prefill-no-data {
                    text-align: center;
                    padding: 40px 20px;
                }
                .prefill-no-data-img {
                    max-width: 130px;
                    margin-bottom: 16px;
                    opacity: 0.8;
                }
                .prefill-no-data-text {
                    font-size: 15px;
                    font-weight: 600;
                    color: #64748b;
                }
            `}</style>

            <div className="prefill-popup-backdrop" onClick={() => hnadlePrefetchPopupOpenPopup(false)}>
                <div className="prefill-popup-card" onClick={(e) => e.stopPropagation()}>
                    <button className="prefill-close-btn" onClick={() => hnadlePrefetchPopupOpenPopup(false)}>
                        &times;
                    </button>
                    <div className="prefill-title">Compare Prefilled Customer Data</div>
                    
                    {loader && <Loader />}
                    
                    {hasData ? (
                        <>
                            {/* Overall Status Card */}
                            <div className="prefill-overall-card">
                                <span className="prefill-overall-title">Verification Matching Summary</span>
                                <div className="prefill-overall-info">
                                    <span className={`prefill-overall-status ${prefillData.overallStatus?.toLowerCase() === 'matched' ? 'matched' : 'not_matched'}`}>
                                        {prefillData.overallStatus?.replace('_', ' ')}
                                    </span>
                                </div>
                            </div>

                            {/* Comparison Table */}
                            <div className="prefill-table-wrapper">
                                <table className="prefill-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '18%' }}>Field</th>
                                            <th style={{ width: '33%' }}>App Details Value</th>
                                            <th style={{ width: '33%' }}>CIBIL/Prefill Value</th>
                                            <th style={{ width: '16%' }}>Match Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comparisonRows.map((row, index) => {
                                            const isMatch = row.data.status?.toUpperCase() === 'MATCHED';
                                            const hasScore = row.data.percentage !== undefined && row.data.percentage !== null;
                                            return (
                                                <tr key={index}>
                                                    <td className="prefill-field-label">{row.label}</td>
                                                    <td>{row.data.detailsValue || 'N/A'}</td>
                                                    <td>{row.data.prefillValue || 'N/A'}</td>
                                                    <td>
                                                        <span className={`prefill-badge ${isMatch ? 'matched' : 'not_matched'}`}>
                                                            {row.data.status?.replace('_', ' ')}
                                                            {hasScore && ` (${row.data.percentage}%)`}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        !loader && (
                            <div className="prefill-no-data">
                                <img className="prefill-no-data-img" src={NoData} alt="No Data" />
                                <div className="prefill-no-data-text">No Comparison data found for this applicant.</div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
}
